// eslint-disable-next-line import/no-cycle
import {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  ME_LOGOUT,
  ME_LOGOUT_SUCCESS,
  ME_LOGOUT_ERROR,
} from '../actions';

export const getProfile = (callback) => ({
  type: GET_PROFILE,
  callback,
})
export const getProfileSuccessed = (data) => ({
  type: GET_PROFILE_SUCCESS,
  payload: data,
});
export const getProfileFailed = (error) => ({
  type: GET_PROFILE_ERROR,
  payload: error
});

export const logout = (callback) => ({
  type: ME_LOGOUT,
  callback,
})
export const logoutSuccessed = (data) => ({
  type: ME_LOGOUT_SUCCESS,
  payload: data,
})
export const logoutFailed = (error) => ({
  type: ME_LOGOUT_ERROR,
  payload: error
});